import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            When I'm not coding, you can find me enjoying life through these fun activities:</p>
          <ul>
            <li className="about-activity">
            ✈️ Wanderlust: I love packing my bags and exploring new places, soaking up the culture and beauty of our diverse world.
            </li>
            <br></br>
            <li className="about-activity">
            🍲 Master Chef: Whipping up new recipes and experimenting with different cuisines is both delicious and enlightening.
            </li>
            <br></br>
            <li className="about-activity">
            📸 Say Cheese: Capturing moments and stories through my camera lens helps me see the world in a whole new light. 
            </li>
            <br></br>
            <li className="about-activity">
            🎮 Gamer Alert: You'll often find me with my Nintendo Switch, especially when it comes to the enchanting world of Zelda!
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
